// import { fromJS } from "immutable";

// import {
//   LOGIN_ACTION_SUCCEEDED,
//   SIGNUP_ACTION_SUCCEEDED
// } from "../../components/Login/constants";
import {
  LOGIN_HANDLE_CHANGE,
  SIGNUP_HANDLE_CHANGE,
  LOGIN_ACTION_SUCCEEDED,
  SIGNUP_ACTION,
  SIGNUP_ACTION_SUCCEEDED,
  SIGNUP_ACTION_FAILED,
  FORGOT_PASSWORD_HANDLE_CHANGE,
  FORGOT_PASSWORD_ACTION,
  FORGOT_PASSWORD_ACTION_SUCCEEDED,
  FORGOT_PASSWORD_ACTION_FAILED,
  RESET_PASSWORD_ACTION,
  RESET_PASSWORD_ACTION_SUCCEEDED,
  RESET_PASSWORD_ACTION_FAILED,
  RESEND_ACTIVATION_HANDLE_CHANGE,
  RESEND_ACTIVATION_ACTION_SUCCEEDED,
  RESEND_ACTIVATION_ACTION_FAILED,
  LOGIN_ACTION,
  LOGOUT_ACTION_SUCCEEDED,
  LOGOUT_ACTION_FAILED,
  LOGIN_ACTION_FAILED,
  RESEND_ACTIVATION_ACTION,
  FETCH_COUNTRIES_REQUEST,
  FETCH_COUNTRIES_SUCCESS,
  FETCH_COUNTRIES_FAILURE
} from "../../common/constants";

export const loginReducer = (
  state = { username: "", password: "", btnDisabled: false },
  action
) => {
  switch (action.type) {
    case LOGIN_ACTION_SUCCEEDED:
      return {
        ...state,
        btnDisabled: false,
        loginInfo: action.loginInfo
      };
    case LOGIN_ACTION_FAILED:
      return {
        ...state,
        btnDisabled: false
      };
    case LOGIN_ACTION:
      return { ...state, btnDisabled: true };
    case LOGIN_HANDLE_CHANGE:
      return { ...state, [action.name]: action.value };
    default:
      return state;
  }
};

const signupInitState = {
  name: "",
  username: "",
  password: "",
  company: "",
  btnDisabled: false
};
export const signupReducer = (
  state = {
    name: "",
    username: "",
    password: "",
    company: "",
    btnDisabled: false,
    requireRecaptchaV2: false
  },
  action
) => {
  switch (action.type) {
    case SIGNUP_ACTION_SUCCEEDED:
      return {
        ...state,
        name: "",
        username: "",
        password: "",
        company: "",
        btnDisabled: false,
        requireRecaptchaV2: false
      };
    case SIGNUP_ACTION:
      return { ...state, btnDisabled: true };
    case SIGNUP_ACTION_FAILED:
      return {
        ...state,
        btnDisabled: false,
        requireRecaptchaV2: (action.args && action.args.requireRecaptchaV2) || false
      };
    case SIGNUP_HANDLE_CHANGE:
      return { ...state, [action.name]: action.value };
    default:
      return state;
  }
};

export const forgotPasswordReducer = (
  state = {
    username: "",
    password: "",
    confirmpassword: "",
    reset_pwd_token: "",
    btnDisabled: false
  },
  action
) => {
  switch (action.type) {
    case FORGOT_PASSWORD_ACTION_SUCCEEDED:
      return {
        ...state,
        username: "",
        password: "",
        confirmpassword: "",
        reset_pwd_token: "",
        btnDisabled: false
      };
    case FORGOT_PASSWORD_ACTION_FAILED:
      return { ...state, btnDisabled: false };
    case FORGOT_PASSWORD_ACTION:
      return { ...state, btnDisabled: true };

    case RESET_PASSWORD_ACTION_SUCCEEDED:
      return {
        ...state,        
          username: "",
          password: "",
          confirmpassword: "",
          reset_pwd_token: "",
          btnDisabled: false
        
      };
    case RESET_PASSWORD_ACTION_FAILED:
      return { ...state, btnDisabled: false };
    case RESET_PASSWORD_ACTION:
      return { ...state, btnDisabled: true };
    case FORGOT_PASSWORD_HANDLE_CHANGE:
      return { ...state, [action.name]: action.value };
    default:
      return state;
  }
};

export const resendActivationReducer = (
  state = { username: "", btnDisabled: false },
  action
) => {
  switch (action.type) {
    case RESEND_ACTIVATION_ACTION_SUCCEEDED:
      return { ...state, username: "", btnDisabled: false };

    case RESEND_ACTIVATION_ACTION_FAILED:
      return { ...state, btnDisabled: false };
    case RESEND_ACTIVATION_ACTION:
      return { ...state, btnDisabled: true };

    case RESEND_ACTIVATION_HANDLE_CHANGE:
      return { ...state, [action.name]: action.value };

    default:
      return state;
  }
};

export const logoutReducer = (state = {}, action) => {
  switch (action.type) {
    case LOGOUT_ACTION_SUCCEEDED:
      return { ...state };
    default:
      return state;
  }
};

// export default loginReducer;


const countryInitialState = {
  countries: [],
  loading: false,
  error: null
};

export default function countryReducer(state = countryInitialState, action) {
  switch (action.type) {
    case FETCH_COUNTRIES_REQUEST:
      return {
        ...state,
        loading: true
      };
    case FETCH_COUNTRIES_SUCCESS:
      return {
        ...state,
        loading: false,
        countries: action.payload
      };
    case FETCH_COUNTRIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Login/reducer.js